export var getReviewStats = function (state) {
    return state.reviewStats || null;
};
